export default __webpack_public_path__ + "static/media/histogram-blue-no-bar-spacing.9c534735.svg";